import { Tooltip, Typography, TypographyVariant } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { LogSearchKind, Role } from "../../app/backendTypes";

function ErrorSpan(props: { error: string; variant?: TypographyVariant }) {
  const { error, variant } = props;

  const auth = useAppSelector((state) => state.auth);
  const isAdmin = auth.roles.includes(Role.Administrator);

  const nagivate = useNavigate();

  const typo = (
    <Typography
      component="span"
      color="error"
      variant={variant}
      style={{
        textDecoration: "underline",
        textDecorationStyle: "dotted",
        fontWeight: "bold",
      }}
      onClick={
        isAdmin
          ? () =>
              nagivate(
                `/admin/logs?kind=${LogSearchKind.Request}&value=${error}`
              )
          : undefined
      }
    >
      error
    </Typography>
  );

  return isAdmin ? (
    typo
  ) : (
    <Tooltip arrow placement="top" title={error}>
      {typo}
    </Tooltip>
  );
}

export default ErrorSpan;
